import styled from '@emotion/styled'

const boxShadowColor = '0 4px 15px 0 rgb(31 43 58 / 10%)'
// 在这里设置位置
// 注意：目前的定位是relative,想要定位在父级（center,right）固定位置，把注释的内容打开。
const StyledMessage = styled.div`
  /* padding: 1rem 1.25rem; */
  margin-bottom: 2rem;
  border-radius: 4px;
  position: relative;
  margin-top: 2rem;
  /* position:absolute;
  width:650px;
  height:40px;
  line-height:40px;
  padding-left:10px; 
  box-sizing: border-box; */
  top: ${(props) => {
    const { position } = props
    if (position) {
      const top0 = position.split(' ')[0]
      if (top0 === 'top' || top0 === 'center') {
        return 0
      }
    }
    return ''
  }};

  left: ${(props) => {
    const { position } = props
    if (position) {
      const top0 = position.split(' ')[1]
      if (top0 === 'left' || top0 === 'center') {
        return 0
      }
    }
    return ''
  }};
  bottom: ${(props) => {
    const { position } = props
    if (position) {
      const top0 = position.split(' ')[0]

      if (top0 === 'center' || top0 === 'bottom') {
        return 0
      }
    }
    return ''
  }};
  right: ${(props) => {
    const { position } = props
    if (position) {
      const top0 = position.split(' ')[1]

      if (top0 === 'center' || top0 === 'right') {
        return 0
      }
    }
    return ''
  }};
  /* margin:auto; */

  box-shadow: ${(props) => {
    const { styledType } = props
    if (styledType === 'pro') {
      return boxShadowColor
    }
    return 'transparent'
  }};

  background: ${(props) => {
    const { styledType, backgroundColor } = props
    if (styledType === 'pro') {
      return '#fff'
    }
    return backgroundColor
  }};
  border-color: ${(props) => {
    const { borderColor } = props
    return borderColor
  }};
  border: ${(props) => {
    const { styledType } = props
    if (styledType === 'pro') {
      return 'none'
    }
    return '1px solid transparent'
  }};
  border-left: ${(props) => {
    const { styledType, borderColor } = props
    if (styledType === 'pro') {
      return `4px solid ${borderColor}`
    }
    return ''
  }};
  color: ${(props) => {
    const { styledType, textColor } = props
    if (styledType === 'pro') {
      return '#526484'
    }
    return textColor
  }};
  font-size: ${(props) => {
    const { fontSize } = props
    return fontSize
  }};
  /* border:1px solid red; */
`

export default StyledMessage
